import React, { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    children: ReactNode;
    className?: string;
};

export function PrimaryButton({ children, className = "", ...props }: ButtonProps) {
    return (
        <button
            className={`inline-flex items-center gap-2 rounded-2xl bg-blue-600 px-5 py-2.5 text-white font-semibold shadow-sm hover:bg-blue-700 transition ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}

export function SecondaryButton({ children, className = "", ...props }: ButtonProps) {
    return (
        <button
            className={`inline-flex items-center gap-2 rounded-2xl border border-gray-300 bg-white px-5 py-2.5 text-gray-800 font-semibold shadow-sm hover:bg-gray-50 transition ${className}`}
            {...props}
        >
            {children}
        </button>
    );
}
